import { Box, Typography } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const AuthFooter = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: { xs: '100%', md: '85%' },
        mx: 'auto',
      }}
    >
      {/* Centered copyright text */}
      <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.85rem', opacity: 0.6 }}>
        {currentYear} CoinFox - {t('common.allRightsReserved')}
      </Typography>
    </Box>
  );
};

export default AuthFooter;
